/* src/app/core/components/menu/menu.component.scss */
.nav {
  background-color: white;
  max-width: 6.25rem;
  height: 100%;
}
.nav ul {
  width: 100%;
}
.list-group-item svg path {
  fill: #4a5057;
}
.list-group-item.active svg path {
  fill: white;
}
.list-group-item-action {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 3px;
}
.list-group-item-action b {
  text-align: center;
}
.main-menu .list-group-item:hover,
.main-menu .list-group-item:hover a {
  background: #5f74c1;
  color: white;
}
.main-menu ul.list-group li {
  border: none;
  border-radius: 0;
  font-size: 0.9em;
}
.main-menu ul.list-group li.active {
  background-color: #3e53a4;
  color: white;
}
.main-menu > div {
  padding: 0;
}
.badge-notification {
  display: inline-block;
  margin-left: 0.5rem;
  padding: 0.25rem 0.5rem;
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  border-radius: 0.35rem;
  background-color: #ffc107;
  color: #000;
  min-width: 1.2rem;
}
/*# sourceMappingURL=menu.component.css.map */
